<div class="modals modal-contacts" [class.modals-show]="isModalContactsShow">
  <a class="close-modal" (click)="closeModal()"></a>

  <div class="contacts">
    <h4>Контактна інформація</h4>
    <ng-container *ngIf="user && user.user_id != 6711 && user.admin_id != 6711">
      <div>
        <ul class="socials_wrap">
          <ng-container *ngFor="let requisites of infoSupportRequisites">
            <li *ngIf="requisites.type === 'viber'">
              <a href='viber://chat?number={{requisites.value}}'>
                <img src='/assets/images/soc-icons/viber.png'>
              </a>
            </li>

            <li *ngIf="requisites.type === 'telegram'">
              <a href='tg://resolve?domain={{requisites.value}}'>
                <img src='/assets/images/soc-icons/telegram.png'>
              </a>
            </li>

            <li *ngIf="requisites.type === 'whatsapp'">
              <a href='whatsapp://send?phone={{requisites.value}}'>
                <img src='/assets/images/soc-icons/whatsapp.png'>
              </a>
            </li>

            <li *ngIf="requisites.type === 'email'">
              <a href='mailto:{{requisites.value}}'>
                <img src='/assets/images/soc-icons/mail.png'>
              </a>
            </li>

            <li *ngIf="requisites.type === 'phone'">
              <a href='tel:{{requisites.value}}'>
                <img src="/assets/images/soc-icons/phn.png">
              </a>
            </li>
          </ng-container>
        </ul>
      </div>

      <ng-container *ngFor="let requisites of infoSupportRequisites">
        <div *ngIf="requisites.type == 'text_info'" class="manager info-circle-position">
          <span class="contact_info" [innerHTML]="requisites.value"></span>
          <i *ngIf="requisites.id == 1" class="fa fa-info-circle info-icon" (click)="openInfoTelegramModal()"></i>
        </div>
      </ng-container>
    </ng-container>

    <div *ngIf="contacts_drivers !== ''" class="manager">
      <span class="contact_info" [innerHTML]="contacts_drivers"></span>
    </div>

    <ng-container *ngIf="delivery && delivery.length">
      <ng-container *ngFor="let del of delivery">
        <div *ngIf="del.contacts !== ''" class="manager">
          <span class="contact_info" [innerHTML]="del.contacts"></span>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngFor="let requisites of admins_requisites">
      <div class="manager" *ngIf="requisites.type === 'phone' || requisites.type === 'email'">
        <span class="contact_info" [innerHTML]="requisites.value"></span>
      </div>
    </ng-container>

    <div class="row">
      <div class="column"></div>
      <div class="column shrink">
        <div class="soc_icons">
          <a href="https://www.tiktok.com/@maslotochka.com.ua?_t=ZM-90XTwEgDN99&_r=1"
             target="_blank"
             rel="nofollow"
          >
            <img class="icon-tiktok" src="/assets/images/soc-icons/tiktok.png" alt="tiktok">
          </a>
          <a href="https://www.facebook.com/maslotochka.com.ua/videos/733358287410395/?d=n"
             target="_blank"
             rel="nofollow">
            <img src="/assets/images/soc-icons/facebook-blue.png" alt="facebook icon">
          </a>
          <a href="https://instagram.com/maslotochka.com.ua"
             target="_blank"
             rel="nofollow">
            <img src="/assets/images/soc-icons/insta-origi.png" alt="instagram icon">
          </a>
        </div>
      </div>
      <div class="column"></div>
    </div>
  </div>
</div>

<div class="modal" [class.modal-show]="infoModalShow">
  <h4>ІНСТРУКЦІЯ ДЛЯ БОТА «ЯК КОРИСТУВАТИСЬ БОТОМ»</h4>
  <ol class="instruction">
    <li>В додатку Телеграм додаєте у наш Бот @MaslotochkacomBot свій логін (email пошту, яку використовуєте на сайті
      Maslotochka, можливо переглянути в меню, налаштування акаунту) та відправляєте, потім відправляєте Ваш пароль
      (можливо самостійно відновити або звернутися до адміністратора сайту).
    </li>
    <li>При необхідності, фукцію повідомлень від Maslotochka можливо самостійно налаштувати (включити або відключити
      відповідні теми) для цього заходимо в меню - налаштування акаунту - налаштування повідомлень та обираємо
      необхідне. Після натискаємо кнопку «зберегти».
    </li>
    <li>Для того, щоб відписатись від @MaslotochkacomBot, в меню @MaslotochkacomBot натискаємо кнопку зупинити бота.
    </li>
  </ol>
  <div class="row">
    <a class="button btn-understand" (click)="understand()">Зрозуміло</a>
  </div>
</div>

<div class="dark-layer" [class.modals-show]="isDarkBackground" (click)="closeModal()"></div>
